import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";
import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

export const getCurrencyToken = async (Token) => {
    const result = await PublicInterceptor(`Base/Global/Currency/Monedas/token`, 'GET', {}, Token);
    return result;
}

export const getCurrency = async () => {
    const result = await PrivateInterceptor(`Base/Global/Currency`, 'GET');
    return result;

}

export const getCurrencyIPS = async () => {
    const result = await PrivateInterceptor(`Base/Global/Currency/currencyIPS`, 'GET');
    return result;
}

export const getBancosList = async(Token) => {
    const result = await PublicInterceptor('Base/Global/Bancos', 'GET', {}, Token);
    return result;

}